import { Component, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Appointment, NetworkMember, Family, FamilyPatient, PatientEntity, ChecklistTemplate, TeamMember, GetAppointments, FamilyEntity, ServiceLevelServices, SchedulingStateModel,  AppointmentChecklist, ServiceLevelService } from 'huddyapi';

import moment_ from 'moment';
import { MatTable } from "@angular/material/table";
import { CalendarBackEndPair } from '../../todo/calendar-view/calendar-view';
import { EditCalendarEventDialog } from '../../components/edit-calendar-event-dialog/edit-calendar-event-dialog.component';
import { Observable, Subscription, timer } from 'rxjs';
import { TodoComponent } from '../../todo/todo.component';
import { CommunityConfigService } from '../../services/community-config.service';
import { AppComponent } from '../../app.component';
import { GetServiceLevelsForTeamIds } from 'huddyapi';






@Component({
  selector: 'family-appointments',
  templateUrl: './family-appointments.component.html',
  styleUrls: ['./family-appointments.component.scss']
})
export class FamilyAppointmentsComponent  {

  @Input() appointments : Appointment[];
  @Input() user : string;
  @Input() checklistTemplates : ChecklistTemplate[];
  @Input() family : FamilyEntity;


  currentTeamMembers : TeamMember[];

  appointmentRows : AppointmentRow[];
  currentServiceLevels : ServiceLevelServices[];
  @Select(state => state.schedulingState) schedulingState$: Observable<SchedulingStateModel>;
  @ViewChild(MatTable) table: MatTable<any>;
  selectedRows : AppointmentRow[] = [];
  schedulingSubscription : Subscription;

  static COMPLETED : string[] = ['COMPLETED', 'OCCURRED', 'FOLLOWED_UP'];
  static PENDING : string[] = ['Scheduled', 'To Be Scheduled'];
  displayColumns : string[] = ['select', 'isLate', 'sequenceNum', 'startDateTime', 'status', 'expectedDateTime', 'teamMemberName','description', 'checklistName', 'requiredItems', 'memberCompletionScore', 'coordinatorCompletionScore'];


  constructor(
    private store : Store,
    public router: Router,
    public dialog: MatDialog,
    public matIconRegistry : MatIconRegistry  ) {


    this.store.dispatch(new GetServiceLevelsForTeamIds(CommunityConfigService.fullTeams.map(pg => pg.id)));
  }

  ngOnInit() {

    this.currentTeamMembers = CommunityConfigService.allMembers;
    this.buildAppointmentRows();
    this.schedulingSubscription = this.schedulingState$.subscribe((schedulingState : SchedulingStateModel) => {

      if ( schedulingState.serviceLevelServices && schedulingState.serviceLevelServices.length > 0 && !this.currentServiceLevels) {
        this.currentServiceLevels =  schedulingState.serviceLevelServices;
        console.log('setting currentServiceLevels', schedulingState.serviceLevelServices, this.currentServiceLevels);
      }


  });

  }


  hasAppointmentsToShow() {
    return this.appointments && this.appointments.length > 0;
  }


  buildAppointmentRows() {
    console.log('buildAppointmentRows', this.hasAppointmentsToShow(), this.appointments, this.currentTeamMembers.map(tm => tm.id), this.currentTeamMembers);
    let teamMemberIds : number[] = this.currentTeamMembers.map(tm => tm.id);
      this.appointmentRows = this.appointments
      .filter(a => this.family.status === 'RECRUITED' || (a.teamMembers && a.teamMembers.map(tm => tm.id).filter(id => teamMemberIds.indexOf(id) > -1).length > 0))
      .sort((a, b) => (a.startDateTime < b.startDateTime ? -1 : 1)).map(a => {
        let requiredItems : string = 'None';
        if (a.checklist) {
          const requiredItemsArr : string[] = a.checklist.checklistItems
              .filter(cli => cli.required)
              .map(cli => cli.item + " (" + cli.requiredByAppNum + ")");
          if (requiredItemsArr.length > 0) {
            requiredItems = requiredItemsArr.join(',');
          }
        }

        let teamMemberName : string = '';
        const teamMembers = this.currentTeamMembers.filter(tm => a.teamMembers.map(tm2 =>tm2.id).indexOf(tm.id) > -1);
        if (teamMembers && teamMembers.length > 0) {
          teamMemberName = teamMembers.map(teamMember => {
            let tmn = teamMember.email;
            const idx = tmn.indexOf('@');
            if (idx > -1) {
              tmn = tmn.substring(0, idx);
            }
            return tmn;
          }).join(',');
        }

        let row : AppointmentRow =  ({
          id : a.id,
          status : a.status.toLowerCase().split('_').map((word: any) => {
            return (word.charAt(0).toUpperCase() + word.slice(1));
          }).join(' '),
          startDateTime : FamilyAppointmentsComponent.getDateFromTimestamp(a.startDateTime),
          description : a.description,
          teamMemberName : teamMemberName,
          sequenceNum : a.sequenceNum,
          expectedDateTime : a.templateDatetime ? FamilyAppointmentsComponent.getDateFromTimestamp(a.templateDatetime) : undefined,
          isLate : a.isLate,
          memberCompletionScore : a.memberCompletionScore,
          coordinatorCompletionScore : a.coordinatorCompletionScore,
          checklistName : a.checklist ? a.checklist.name : '',
          requiredItems :requiredItems

        });
        return row;
    }).sort();

  }

  getColorFromName(name : string) : string {
    let ret : string = '#DAC7FD';
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }

 getInitial(patient : PatientEntity) {
  let ret : string = 'P';
  if (patient) {
    if (patient.firstName)
      ret = patient.firstName.substring(0,1);
    else
      ret = patient.username.substring(0,1);
  }
  return ret;
 }

 getFriendlyName(patient : PatientEntity) {
  let ret =  patient.firstName ? patient.firstName + ' ' : '';
  if (patient.lastName)
    ret = ret + patient.lastName;
  return ret;
 }

  onDelete() {
    // this.store.dispatch(new DeleteReminder(reminder.id)).subscribe(t => {
    //   timer(3000).subscribe(t => this.store.dispatch(new GetReminderForUsername(this.patient.username)));
    // });
  }

  onAppointmentSelected($event, row: AppointmentRow) {
   const idx : number = this.selectedRows.indexOf(row);
   if ($event.checked && idx === -1) {
    this.selectedRows.push(row);
   }
   if (!$event.checked && idx > -1) {
    this.selectedRows.splice(idx, 1);
   }
   //console.log($event, row, this.selectedRows);
  }

  canEditSelected() {
    return this.selectedRows.length === 1;
  }

  canMergeSelected() {

    if ( this.selectedRows.length > 1) {
      let filtered : AppointmentRow[] =  this.selectedRows.filter(a => FamilyAppointmentsComponent.PENDING.indexOf(a.status) > -1);
      if (filtered.length > 1) {
        let teamMemberNames : string[] = this.selectedRows.map(row => row.teamMemberName);
        teamMemberNames = teamMemberNames.filter(distinct);
        return teamMemberNames.length === 1;
      }
    }
    return false;
  }

  static getDateFromTimestamp(ts : number) : number {
    let ret : number = 60 * (new Date().getTimezoneOffset());
    ret = ret + ts;
    ret = ret * 1000;
    return ret;
  }

  isAppointmentLate(row : AppointmentRow) {
    const appointment = this.appointments.find(app => app.id === row.id);
    if (!appointment) {
      return false;
    }
    return appointment.isLate ||
    (FamilyAppointmentsComponent.COMPLETED.indexOf(appointment.status) > -1 && appointment.checklist &&
      appointment.checklist.checklistItems.some(ci => ci.required && ci.requiredByAppNum <= appointment.sequenceNum));
  }

  changeSort($event : any) {
    console.log($event);
    if ($event.active === 'isLate') {
      this.appointmentRows = this.appointmentRows.sort((a, b) => {
        const isLateA : boolean = this.isAppointmentLate(a);
        const isLateB : boolean = this.isAppointmentLate(b);
        if (isLateA && !isLateB) {
          return ($event.direction === 'asc') ? -1 : 1;
        }
        if (isLateB && !isLateA) {
          return ($event.direction === 'asc') ? 1 : -1;
        }
        return 0;
      });
    } else {
      this.appointmentRows = this.appointmentRows.sort((a, b) =>
        (($event.direction === 'asc') ? a[$event.active] < b[$event.active] ? -1 : 1: a[$event.active] > b[$event.active]? -1 : 1));

    }
    this.table.renderRows();
  }



  edit(row : AppointmentRow, a? :Appointment) {

    if (!row && this.selectedRows && this.selectedRows.length === 1) {
      row = this.selectedRows[0];
    }
    let pair : CalendarBackEndPair;
    let appointment : Appointment;
    if (row || a) {
      appointment = a ? a : this.appointments.find(a => a.id === row.id);
      pair = {
        action: 'Edit',
        username : this.user,
        checklistTemplates : this.checklistTemplates,
        calendarEvent : undefined,
        backendEvent : {
          id: appointment.id,
          start: new Date(FamilyAppointmentsComponent.getDateFromTimestamp(appointment.startDateTime)),
          end: new Date(FamilyAppointmentsComponent.getDateFromTimestamp(appointment.endDateTime)),
          text: appointment.description,
          checklistId : (appointment.checklist) ? appointment.checklist.id : undefined,
          sourceType : 'Appointment',
          status : appointment.status,
          appointmentType: appointment.appointmentType,
          teamMembers: appointment.teamMembers,

        }
      };
    } else {
      pair = {
        action: 'Requested',
        calendarEvent: undefined,
        backendEvent: undefined,
        username : this.user,
        checklistTemplates : this.checklistTemplates
      }
    }
    let family : Family = undefined;
    if (this.family) {
      let primary : FamilyPatient = this.family.patients.find(fp => fp.relationship === 'PRIMARY');
        family = {
        id : this.family.id,
        identifier: this.family.identifier,
        hasLateAppointments : this.family.hasLateAppointments,
        lateEvaluationState :this.family.evaluationLatenessState,
        namedPrimary : this.getFriendlyName(primary.patient),
        primaryAddress : (primary.patient.addresses && primary.patient.addresses.length > 0) ? primary.patient.addresses[0].street1 : '',
        primaryPhone: (primary.patient.phones && primary.patient.phones.length > 0) ? primary.patient.phones[0].number : '',
        status : this.family.status,
        serviceLevel : undefined,
        tags: this.family.tags ? this.family.tags.map(t => t.text).join(',') : '',
        teams: []
      };
    }

      console.log('edit', pair, this.currentServiceLevels);
      const height: string = '700px';
      const dialog = this.dialog.open(EditCalendarEventDialog, {
        width: '600px',
        height: height,
        data: {
          pair: pair,
          family: family,
          currentTeam : undefined,
          currentMembers : this.currentTeamMembers,
          appointment : appointment,
          serviceLevels : this.currentServiceLevels
        }
    });
    dialog.afterClosed().subscribe(() => {
      timer(1500).subscribe(() => {
        this.selectedRows = [];
        this.store.dispatch(new GetAppointments(this.family.id));
      });
    });

  }




  merge() {
    let appointments : Appointment[] = this.selectedRows.map(row => this.appointments.find(a => a.id === row.id));
    console.log('entering merge', this.selectedRows, appointments);
    let sourceTemplateIds : number[] = [];
    let mergedFrom : number[] = appointments.map(a => a.id);
    let checklist : AppointmentChecklist = {
      id : undefined,
      name : "Merged",
      appointmentId : undefined,
      sourceTemplateIds : [],
      checklistItems : [],
      workerScore : 0,
      managerScore : 0
    }
    let status : string = appointments.findIndex(a => a.status === 'SCHEDULED') === -1 ? 'TO_BE_SCHEDULED' : 'SCHEDULED';
    const sequenceNumbers = appointments.map(a => a.sequenceNum);

    let sequenceNumber : number = Math.min( ...sequenceNumbers );
    let requiredServices : ServiceLevelService[] = [];
    for (let a of appointments) {
      sourceTemplateIds = sourceTemplateIds.concat(a.sourceTemplateIds);
      if (a.checklist) {
       checklist.sourceTemplateIds = checklist.sourceTemplateIds.concat(a.checklist.sourceTemplateIds);
       for (let ci of a.checklist.checklistItems) {
          let idx : number = checklist.checklistItems.findIndex(ci2 => ci.serviceId === ci2.serviceId && ci.item === ci2.item);
          if (idx === -1) {
            checklist.checklistItems.push(ci);
          }
        }
      }
      for (let s of a.requiredServices) {
        console.log('source rs', a.requiredServices);
        let idx : number = requiredServices.findIndex(s2 => s.id === s2.id);
        if (idx === -1) {
          requiredServices.push(s);
        }
      }

    }
    sourceTemplateIds = sourceTemplateIds.filter(distinct);
    checklist.sourceTemplateIds = checklist.sourceTemplateIds.filter(distinct);
    let merged:  Appointment = {
      familyId: appointments[0].familyId,
      familyIdentifier: appointments[0].familyIdentifier,
      familyPrimary : appointments[0].familyPrimary,
      addressId :appointments[0].addressId,
      phoneId: appointments[0].phoneId,
      startDateTime : appointments[0].startDateTime,
      endDateTime : appointments[0].endDateTime,
      teamMembers : appointments[0].teamMembers,
      description : "Merged",
      sourceTemplateIds : sourceTemplateIds,
      memberCompletionScore : 0,
      coordinatorCompletionScore : 0,
      sequenceNum : sequenceNumber,
      status : status,
      requiredServices : requiredServices,
      checklist : checklist,
      mergedFrom : mergedFrom
    }
    this.edit(undefined, merged);
  }
}



export interface AppointmentRow {
  id : number;
  status : string;
  startDateTime : number;
  description : string;
  sequenceNum : number;
  teamMemberName : string;
  expectedDateTime : number;
  isLate? : boolean;
  memberCompletionScore? : number;
  coordinatorCompletionScore? : number;
  checklistName? : string;
  requiredItems? : string;
}

export function distinct(value, index, array) {
  return array.indexOf(value) === index;
}
